import { ShareCaseConfig, ShareCaseArgs } from './types';
import { ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';
import { routeConstants } from 'app/routes/route-constants';
import { notifyUser } from 'app/infrastructure/notifications/notify-user';
import { api } from './api';
import { getUserMessage } from 'app/infrastructure/notifications/user-messages/get-user-message';

export const SharePreset: {[key:string]: ShareCaseConfig} = {
  case: {
    getUsers: async (
      caseNumber: number, 
      filterText?: string
    ) => {
      try {
        return await api.getUsersForShareLink(caseNumber, filterText);
      }
      catch (err) {
        notifyUser.error( getUserMessage(err.userMessages) );
        return [];
      }
    },
    shareDocument: async (
      props: ConnectedComponentProps & {caseNumber: number},
      args: Partial<ShareCaseArgs>,
      translate: {[key:string]:string}
    ) => {
      try {
        await api.shareDocument({
          caseId: props.caseNumber,
          linkPath: routeConstants.caseViewFor(props.caseNumber),
          message: args.message,
          recipients: args.recipients
        });
        notifyUser.success(translate.case_was_shared);
      } catch (err) {
        notifyUser.error( getUserMessage(err.userMessages) || translate.share_failed);
      }
    }
  },
  draft: {
    getUsers: async (
      draftId: number,
      filterText?: string,
      domainNoUsers?: number
    ) => {
      try {
        return await api.getUsersForShareLinkDraft(draftId, domainNoUsers, filterText);
      }
      catch (err) {
        notifyUser.error( getUserMessage(err.userMessages) );
        return [];
      }
    }
  }
};
